// src/services/pftSurveyService.js
//
// Sends the PFT health-survey texts through the sendPftSurveySms function (the only
// writer of recipients and of the imports' `survey` field). Rules: pftSurvey.js.

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getCollectionPath } from "./firestorePaths";
import { authedFetch } from "./authedFetch";
import { FUNCTIONS_BASE } from "../config/functionsBase";
import { textRequestFor } from "./pftSurvey";

/** One patient's survey answers (pft_survey_submissions; staff-readable by rule). */
export const loadSurveySubmission = async (submissionId) => {
  const snap = await getDoc(doc(db, getCollectionPath("pft_survey_submissions"), submissionId));
  if (!snap.exists()) throw new Error("not found");
  return { id: snap.id, ...snap.data() };
};

// Texts go out one at a time on the server; 50 per request keeps each well inside
// its time limit.
const CHUNK = 50;

/**
 * Text these cards. Resolves to { sent, skipped, failed, results: [{ key, ok, reason? }] }.
 * Throws a staff-readable message if a request is refused outright; cards already
 * sent before that stay sent.
 */
export const sendPftSurveyTexts = async ({ tenantId, siteId, cards, resend = false }) => {
  const total = { sent: 0, skipped: 0, failed: 0, results: [] };
  for (let i = 0; i < cards.length; i += CHUNK) {
    const res = await authedFetch(`${FUNCTIONS_BASE}/sendPftSurveySms`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tenantId, siteId, resend, cards: cards.slice(i, i + CHUNK).map(textRequestFor) }),
    });
    let body = {};
    try {
      body = await res.json();
    } catch {
      body = {};
    }
    if (!res.ok) {
      const done = total.sent ? ` ${total.sent} were sent before this.` : "";
      throw new Error(`${body.error || "Couldn't send the texts. Please try again."}${done}`);
    }
    total.sent += body.sent || 0;
    total.skipped += body.skipped || 0;
    total.failed += body.failed || 0;
    total.results.push(...(body.results || []));
  }
  return total;
};
